import { IconProps } from "@radix-ui/react-icons/dist/types";
import * as React from "react";

export const HammerIcon = React.memo(function HammerIcon({
  color = "currentColor",
  ...props
}: IconProps) {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.11914 1.0498L9.22363 1.10938L12.7236 3.10938L12.748 3.12305L12.7695 3.13965L13.9277 4.00879C14.5502 4.47569 14.6869 5.34178 14.2637 5.97363L14.1719 6.09668L13.0469 7.44727C12.501 8.10213 11.5101 8.1468 10.9072 7.54395L10.0215 6.6582L4.04297 13.4922C3.52505 14.0841 2.63843 14.1492 2.04102 13.666L1.92578 13.5625L1.34375 12.9795C0.804043 12.4398 0.774888 11.5745 1.27734 11L7.35156 4.05762L6.03027 3.00098C5.39495 2.49259 5.50075 1.49677 6.22852 1.13281L6.31152 1.09668C6.39675 1.06576 6.48701 1.04985 6.57812 1.0498H9.11914ZM6.61133 1.9502C6.48962 2.02801 6.4765 2.20471 6.59277 2.29785L8.64844 3.94238L1.95508 11.5918C1.76441 11.8097 1.77475 12.139 1.97949 12.3438L2.5625 12.9258L2.65332 12.999C2.87736 13.1439 3.18196 13.1088 3.36523 12.8994L9.97852 5.3418L11.5439 6.90723C11.7726 7.13587 12.1484 7.11939 12.3555 6.87109L13.4805 5.52051L13.5449 5.4248C13.6683 5.19105 13.608 4.89377 13.3877 4.72852L12.2529 3.87695L8.88086 1.9502H6.61133Z"
        fill={color}
      />
    </svg>
  );
});
